import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MainpageComponent } from './layouts/mainpage/mainpage.component';
import { SidebarMenuComponent } from './layouts/sidebar-menu/sidebar-menu.component';
import { TopbarComponent } from './layouts/topbar/topbar.component';
import { AuthService } from './core/auth/auth.service';
import { LoginComponent } from './features/auth/login/login.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'Project';
  // private loader = inject(NgxSpinnerService) 
  // openLoader(): void {
  //   this.loader.show(); 

  // }
}
